<template>
    <div>
        <div class="header">
            <div class="header_t">
                <p class="header_tf">易凡云CDN</p>
                <span class="header_ttw">融合主流CDN厂商节点</span>
                <div class="header_b">
                    <span>提供稳定快速的网络访问服务</span>
                    <span>通过全方位的 CDN 质量监控，以及智能易用的节点调度等功能。</span>
                    <span>保障客户的音视频点播、大文件下载、应用及Web加速服务的稳定及连续性</span>
                </div>
            </div>
            <img src="../assets/imgs/priceOne.png" class="fruit_img">
        </div>
        <!-- 易凡云CDN架构 -->
        <div class="bottom_b">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">易凡云CDN架构</div>
                        <div class="product_pc">
                            <img
                                src="../assets/imgs/priceTwo.png"
                                alt=""
                                style="width:760px;height:440px"
                            >
                        </div>
                        <div class="product_pct_b">核心功能及服务</div>
                        <div class="serve_b">
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceThree.png" alt="">
                                <span class="serve_detial_one">无盲区覆盖</span>
                                <span
                                    class="serve_detial_two"
                                >精选主流厂商高质量节点，全面覆盖各地区各运营商的网络，实现全地域无盲区的覆盖</span>
                            </div>
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceFour.png" alt="">
                                <span class="serve_detial_one">零故障品控</span>
                                <span
                                    class="serve_detial_two"
                                >基于第三方APM的全网覆盖和易凡云自研的监控数据，打造易凡CDN 零故障质量保障体系</span>
                            </div>
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceFive.png" alt="">
                                <span class="serve_detial_one">精准智能调度</span>
                                <span
                                    class="serve_detial_two"
                                >支持 DNS、HTTPDNS、HTTP302 调度模式，有效提高访问响应速度，防止劫持，实现全网实时精准调度调度</span>
                            </div>
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceSix.png" alt="">
                                <span class="serve_detial_one">降低回源成本</span>
                                <span
                                    class="serve_detial_two"
                                >自建中间源，消除跨运营商回源慢甚至不可达等问题，保护源站不受边缘节点请求波动影响，节省回源成本</span>
                            </div>
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceSeive.png" alt="">
                                <span class="serve_detial_one">灵活分时计费</span>
                                <span
                                    class="serve_detial_two"
                                >日间、闲时、忙时可分开计费，根据使用场景精细化运营，为用户最大化降低 成本费用</span>
                            </div>
                            <div class="serve_detial">
                                <img src="../assets/imgs/priceEight.png" alt="">
                                <span class="serve_detial_one">私有协议优化</span>
                                <span
                                    class="serve_detial_two"
                                >使用私有传输协议作为 CDN 内部数据交换的基础，确保客户资源在 CDN 内部安全、快速的传输到各个节点，实现客户内容高效、可靠的进行分发</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 热销套餐 -->
        <div class="content_t" >
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pc">
                            <div class="product_pct">促销流量包</div>
                            <div class="total_list">
                                <div class="total_list_detail" style="">
                                    <div class="total_list_detail_t">
                                        <p>入门型</p>
                                        <span>适合日流量小于 1500 MB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>1024 GB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            0.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即领取</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>进阶型</p>
                                        <span>适合日下行流量小于 3 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>5 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            0.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即领取</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>企业型</p>
                                        <span>适合日下行流量小于 15 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>10 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            980.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>专业型</p>
                                        <span>适合日下行流量小于 30 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>30 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            2800.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>电商型</p>
                                        <span>适合图片详情页比较多，访问人流量比较大的电商平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>50 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            4300.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>下载型</p>
                                        <span>适合大型资源站、文件在线下载高并发负载</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>100 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            8800.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>视频型</p>
                                        <span>适合大流量视频点播，多用户观看平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>200 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            17000.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>定制型</p>
                                        <span>适合大流量访问，APP或大型网站平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>1 PB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            55000.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
        								@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 国内外优质节点覆盖 -->
        <div class="bottom_map">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pct">国内外优质节点覆盖</div>
                        <div class="product_pc">
                            <div class="product_pc_detail">
                                <img src="../assets/imgs/priceTen.png" alt="">
                                <p>
                                    全球
                                    <span>2000</span>节点
                                </p>
                            </div>
                            <div class="product_pc_detail">
                                <img src="../assets/imgs/priceEle.png" alt="">
                                <p>
                                    <span>20+</span>运营商覆盖
                                </p>
                            </div>
                            <div class="product_pc_detail">
                                <img src="../assets/imgs/priceTtl.png" alt="">
                                <p>
                                    访问提速
                                    <span>80%</span>
                                </p>
                            </div>
                            <div class="product_pc_detail">
                                <img src="../assets/imgs/pricest.png" alt="">
                                <p>
                                    <span>100 万</span>客户选择
                                </p>
                            </div>
                        </div>
                        <div style="">
                            <img src="../assets/imgs/yazhoumap.png" alt="">
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
export default {
  name: "Fruit",
  data() {
    return {};
  },
  
  
  methods: {
  		shopping(){
  	 window.open("https://cdn-admin.yifancloud.cn/plan/purchase");
  },
   }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.header {
  position: relative;
}
.header .header_t {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 80px;
  left: 348px;
animation: header_t 2s;
}

@keyframes header_t {
  0% {
    opacity: 0;
    transform: translate3d( -200%, 0, 0);
  }
}
.header .header_t .header_tf {
  font-size: 32px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
}
.header .header_t .header_ttw {
  font-size: 40px;
  font-weight: 600;
  color: #0066ff;
  line-height: 40px;
  margin: 23px 0;
  letter-spacing: 5px;
}
.header .header_t .header_b {
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 40px;
}
.header .fruit_img {
  height: 376px;
  width: 100%;
}
.content_t {
  height: 1400px;
  background: #f5f7fd;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  
}
.content_t .product_pc_one {
  position: relative;
}
.content_t .product_pc_one .product_pc {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: product_pc 2s;
}
@keyframes product_pc {
  0% {
    opacity: 0;
    transform: translate3d( -100%,0, 0);
  }
}
.content_t .product_pc_one .product_pc .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 66px 0 66px 0;
}
.content_t .product_pc_one .product_pc .total_list {
  display: flex;
  flex-wrap: wrap;
  width: 1346px;
  height: 1070px;
  justify-content: space-around;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t {
  background-image: url("../assets/imgs/priceNine.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 315px;
  height: 149px;
  position: relative;
  
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t
  p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 20px;
  position: absolute;
  top: 21%;
  left: 8%;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t
  span {
  width: 261px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  position: absolute;
  bottom: 17%;
  left: 8%;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c {
  width: 315px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cp {
  font-size: 16px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #282c33;
  margin-top: 28px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cp
  span {
  color: #ff6b00;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_csp {
  width: 153px;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 38px;
  margin: 28px 0 45px 0;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cpp {
  font-size: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ff6b00;
  line-height: 16px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cpp
  span {
  font-size: 16px;
  margin-left: -10px;
}
.bottom_b {
  height: 1530px;
}
.bottom_b .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: product_pc_one 2s;
}
@keyframes product_pc_one {
  0% {
    opacity: 0;
    transform: translate3d( -100%,0, 0);
  }
}
.bottom_b .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 55px 0;
}
.bottom_b .product_pc_one .product_pct_b {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 121px 0 60px 0;
}
.bottom_b .product_pc_one .serve_b {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 1210px;
  align-items: center;
  justify-content: space-between;
  align-items: baseline;
  height: 558px;
}
.bottom_b .product_pc_one .serve_b .serve_detial {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_b .product_pc_one .serve_b .serve_detial .serve_detial_one {
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 18px;
  margin-bottom: 15px;
}
.bottom_b .product_pc_one .serve_b .serve_detial .serve_detial_two {
  width: 320px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #848b99;
  line-height: 28px;
}
.bottom_map {
  height: 1100px;
}
.bottom_map .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_map .product_pc_one .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 80px 0 55px 0;
}
.bottom_map .product_pc_one .product_pc {
  display: flex;
  width: 900px;
  flex-direction: row;
  justify-content: space-between;
}
.bottom_map .product_pc_one .product_pc .product_pc_detail {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_map .product_pc_one .product_pc .product_pc_detail p {
  margin-top: 9px;
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
}
.bottom_map .product_pc_one .product_pc .product_pc_detail p span {
  color: #0066ff;
}
</style>